import styled from "styled-components";
import { theme } from "styles";

const Button = styled.button`
  display: block;
  width: 100%;
  height: 56px;
  border-radius: 12px;
  line-height: 24px;
  color: ${(props) => theme.colors[props.color]};
  background: ${(props) =>
    `${theme.colors[props.background] || props.background}`};
  border: 1px solid
    ${(props) =>
      theme.colors[props.border || props.background] || props.background};
  transition: none;
  & + & {
    margin-top: 16px;
  }
  ${(props) => props.css}
`;

Button.defaultProps = {
  color: "white",
  background: "primary100",
};

export default Button;
